const words = {
  spanish: {
    title: "Artesanías de la región",
    text1:
      "Visite nuestro almacén de artesanías con productos exclusivos fabricados por artesanos de Salento donde podrá adquirir un lindo souvenir para llevar de recuerdo.",
    text2:
      "Nuestras artesanías son fabricadas 100% a mano, con técnicas tanto regionales como de otros países.",
    text3:
      "No pierdas la oportunidad de llevarte un pedazo de la cultura del Valle!",
  },
  english: {
    title: "Regional Crafts",
    text1:
      "Come visit our crafts store with exclusive products handmade by Salento's craftsmen, here you can buy a souvenir to take home this amazing experience!",
    text2:
      "Every single craft is 100% handmade, using regional and international techniques.",
    text3:
      "Take this once in a lifetime opportunity to bring home a piece of the Cocora Valley!",
  },
};

export default words;
